import { render, staticRenderFns } from "./ProofTeam.vue?vue&type=template&id=26c8543a&scoped=true"
import script from "./ProofTeam.vue?vue&type=script&lang=js"
export * from "./ProofTeam.vue?vue&type=script&lang=js"
import style0 from "./ProofTeam.vue?vue&type=style&index=0&id=26c8543a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c8543a",
  null
  
)

export default component.exports